import { useRef, type ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Popover,
  PopoverAnchor,
  PopoverContent,
} from '@/components/ui/popover';
import { SOURCE_PRODUCT_URL } from '@/utils/source-product';

export function LockedBoardExplanation({
  children,
  open,
  onOpenChange,
  focusSearch,
}: {
  children: ReactElement;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  focusSearch: () => void;
}) {
  const linkRef = useRef<HTMLAnchorElement>(null);
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverAnchor asChild>{children}</PopoverAnchor>
      <PopoverContent
        className="!bg-primary text-fx-neutral-50 w-80 border-0 text-sm"
        align="start"
        data-contract-search-open
        onOpenAutoFocus={event => {
          event.preventDefault();
          linkRef.current?.focus();
        }}
        onEscapeKeyDown={event => {
          event.preventDefault();
          onOpenChange(false);
          focusSearch();
        }}
        onCloseAutoFocus={event => event.preventDefault()}
      >
        <p>
          <FormattedMessage
            defaultMessage="Available with Source Premium"
            description="A job board contract requires a paid Source plan"
          />
        </p>
        <a
          ref={linkRef}
          href={SOURCE_PRODUCT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 inline-flex min-h-6 items-center underline focus-visible:outline"
        >
          <FormattedMessage
            defaultMessage="Learn more"
            description="Button that opens the Source product page in a new tab, for accounts that want to subscribe and unlock a locked sourcing feature"
          />
        </a>
      </PopoverContent>
    </Popover>
  );
}
